/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_TitleInputs */

const da_verify_title = /** @type {(inputs: Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft din e-mail`)
};

/** @type {(inputs: Verify_TitleInputs) => LocalizedString} */
const en_verify_title = da_verify_title;

/**

* @param {Verify_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const verify_title = /** @type {((inputs?: Verify_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_title(inputs)
	return /** @type {LocalizedString} */ ("Bekræft din e-mail")
});